<div class="org-selector-container">
  <div class="org-selector-card">
    <div class="org-selector-header">
      <h2>Select Organization</h2>
      <p class="org-selector-subtitle">Welcome, {{ currentUser?.firstName }}! Please select your organization</p>
    </div>

    <div class="org-selector-body">
      <div *ngIf="organizations.length === 0" class="alert alert-info">
        No organizations available. Please contact your administrator.
      </div>

      <div *ngIf="organizations.length > 0" class="org-list">
        <div 
          *ngFor="let org of organizations" 
          class="org-item"
          [class.selected]="selectedOrg?.orgId === org.orgId"
          (click)="selectOrganization(org)">
          <div class="org-item__header">
            <h4 class="org-item__name">{{ org.orgName }}</h4>
            <span class="org-item__code">{{ org.orgCode }}</span>
          </div>
          <div class="org-item__units">
            <small class="org-item__unit" *ngFor="let unit of org.units">
              <i class="fas fa-building"></i> {{ unit.unitName }}
            </small>
          </div>
        </div>
      </div>
    </div>

    <div class="org-selector-footer">
      <button 
        type="button" 
        class="btn btn-secondary"
        (click)="logout()">
        <i class="fas fa-sign-out-alt"></i> Logout
      </button>
      <button 
        type="button" 
        class="btn btn-primary"
        [disabled]="!selectedOrg || isLoading"
        (click)="confirmSelection()">
        <span *ngIf="!isLoading">
          <i class="fas fa-arrow-right"></i> Continue
        </span>
        <span *ngIf="isLoading">
          <i class="fas fa-spinner fa-spin"></i> Loading...
        </span>
      </button>
    </div>
  </div>
</div>
